import { CheckCircleTwoTone, DownOutlined } from '@ant-design5/icons';
import { ItemType } from 'antd5/es/menu/interface';
import { StyledTitle } from 'components/DataTable/Views/Views.style';
import { Button, Dropdown } from 'components/ui';
import { useContext } from 'react';
import { useTheme } from 'styled-components';
import { DataTableContext } from 'components/DataTable';
import {
  AtlasGqlTableView,
  useGetBladeCardsQuery,
  useGetMakeModelOptionsQuery,
} from 'types/atlas-graphql';

type BladeCardAssetFilter = {
  key: string;
  value: [string];
};

type BladeCardsProps = {
  tableId?: string;
  applyViewToTable: (tableViewToApply?: AtlasGqlTableView) => void;
  onSelect?: () => void;
};

export const BladeCards: React.FC<BladeCardsProps> = ({ tableId, applyViewToTable, onSelect }) => {
  const theme = useTheme();

  const {
    pagination,
    filteredInfo: _filteredInfo,
    sortedInfo,
    tableView,
    updateTableView,
    customizedColumnSet,
    updateCustomizedColumnSet,
    multiSortDef,
    updateMultiSortDef,
  } = useContext(DataTableContext);

  const { data: hotZonesData, loading } = useGetBladeCardsQuery();
  const { data: makeModelData } = useGetMakeModelOptionsQuery({
    variables: {
      makeInput: {
        fieldName: 'blade_make',
      },
      modelInput: {
        fieldName: 'blade_model',
      },
      independentFieldNameForCombinations: 'blade_make',
    },
  });

  const items: ItemType[] = (hotZonesData?.bladeHotZoneTableViews ?? [])
    .filter(view => {
      const viewMake = view.filters.asset?.find(
        (filter: BladeCardAssetFilter) => filter.key === 'assetMake'
      )?.value?.[0];
      const viewModel = view.filters.asset?.find(
        (filter: BladeCardAssetFilter) => filter.key === 'assetModel'
      )?.value?.[0];

      return (
        viewMake &&
        makeModelData?.configuredMakes.existingValues?.includes(viewMake) &&
        viewModel &&
        makeModelData?.configuredModels.existingValues?.includes(viewModel)
      );
    })
    .map(view => ({
      key: view.id,
      label: (
        <StyledTitle>
          {view.id === tableView?.id && <CheckCircleTwoTone twoToneColor={theme.green} />}
          <span>{view.name}</span>
        </StyledTitle>
      ),
      onClick: () => {
        if (tableId) {
          applyViewToTable({ ...view, tableName: tableId });
        }
        if (onSelect) {
          onSelect();
        }
      },
    }));

  return (
    <Dropdown
      menu={{ items, style: { maxHeight: 350, overflowY: 'scroll' } }}
      trigger={['click']}
      placement="bottomLeft"
    >
      <Button data-testid="blade-cards-dropdown" loading={loading}>
        Blade Cards <DownOutlined />
      </Button>
    </Dropdown>
  );
};
